
<template>
  <div class="flex gap-2">
    <div class="w-10 h-9 px-2 bg-EXPONDO-white rounded flex items-center justify-center">
      <ImgView
        src="/icons/shield_tickmark-color.svg"
        alt="Shield color"
      />
    </div>
    <div>
      <div class="text-sm font-bold">
        {{ $t('Premium Guarantee Available') }}
      </div>
      <div class="text-xs">
        {{ $t('Protect your product for longer') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">


export default defineComponent({
  name: 'ExtraGuaranteeInfo',

});

</script>
